"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _TextInput = _interopRequireDefault(require("../form/TextInput"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TableFilter = _ref => {
  let {
    columnName,
    items,
    handleFilterChange,
    className,
    columnClassName,
    columnHeadingClassName,
    resetFilter,
    openFilterList
  } = _ref;
  const [showFilterList, setShowFilterList] = (0, _react.useState)(typeof openFilterList !== 'undefined' ? openFilterList : false);
  const [search, setSearch] = (0, _react.useState)('');
  const [filterItemChecked, setFilterItemChecked] = (0, _react.useState)(Array(items.length).fill(true));
  const [searchChecked, setSearchChecked] = (0, _react.useState)(Array(items.length).fill(true));
  const [searchItems, setSearchItems] = (0, _react.useState)(items);
  const [selectAll, setSelectAll] = (0, _react.useState)(true);
  (0, _react.useEffect)(() => {
    setShowFilterList(false);
    setSearch('');
    setFilterItemChecked(Array(items.length).fill(true));
    setSearchChecked(Array(items.length).fill(true));
    setSearchItems(items);
    setSelectAll(true);
  }, [resetFilter]);
  (0, _react.useEffect)(() => {
    setShowFilterList(false);
  }, [openFilterList]);
  const handleSearch = userSearch => {
    const lowerCaseSearch = userSearch ? userSearch.toLowerCase() : null;
    const tempSearchItems = [];
    const tempSearchChecked = [];
    items.forEach((item, index) => {
      if (!userSearch || userSearch.length === 0 || item.toLowerCase().includes(lowerCaseSearch)) {
        tempSearchItems.push(item);
        tempSearchChecked.push(filterItemChecked[index]);
      }
    });
    setSearch(userSearch);
    setSearchItems(tempSearchItems);
    setSearchChecked(tempSearchChecked);
    const selectedItems = tempSearchItems.filter((item, index) => tempSearchChecked[index] === true);
    handleFilterChange(selectedItems);
    let tempSelectAll = true;
    tempSearchChecked.forEach((tempItem, index) => {
      if (!tempSearchChecked[index]) {
        tempSelectAll = false;
      }
    });
    setSelectAll(tempSelectAll);
  };
  const handleSelectAll = checked => {
    setSelectAll(checked);
    const tempSearchChecked = [...searchChecked];
    const tempFilterItemChecked = [...filterItemChecked];
    tempSearchChecked.forEach((item, index) => {
      tempSearchChecked[index] = checked;
    });
    setSearchChecked(tempSearchChecked);
    const selectedItems = searchItems.filter((item, index) => tempSearchChecked[index] === true);
    items.forEach((tempItem, index) => {
      const searchIndex = searchItems.findIndex(x => x === tempItem);
      if (searchIndex > -1) {
        tempFilterItemChecked[index] = !tempSearchChecked[searchIndex];
      }
    });
    setFilterItemChecked(tempFilterItemChecked);
    handleFilterChange(selectedItems);
  };
  const handleFilterCheckboxClick = item => {
    const tempFilterItemChecked = [...filterItemChecked];
    const tempSearchChecked = [...searchChecked];
    const tempSearchItems = [...searchItems];
    items.forEach((tempItem, index) => {
      if (tempItem === item) {
        tempFilterItemChecked[index] = !tempFilterItemChecked[index];
      }
    });
    setFilterItemChecked(tempFilterItemChecked);
    tempSearchItems.forEach((tempItem, index) => {
      if (tempItem === item) {
        tempSearchChecked[index] = !tempSearchChecked[index];
      }
    });
    setSearchChecked(tempSearchChecked);
    let tempSelectAll = true;
    tempSearchChecked.forEach((tempItem, index) => {
      if (!tempSearchChecked[index]) {
        tempSelectAll = false;
      }
    });
    setSelectAll(tempSelectAll);
    const selectedItems = searchItems.filter((tempItem, index) => tempSearchChecked[index] === true);
    handleFilterChange(selectedItems);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `table-filter-container ${className}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `column-heading ${columnHeadingClassName}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `column-name ${columnClassName}`
  }, /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: _dompurify.default.sanitize(columnName, {
        USE_PROFILES: {
          html: true
        }
      })
    }
  })), /*#__PURE__*/_react.default.createElement("a", {
    className: "material-icons is-size-5 has-text-black pl-2",
    onClick: event => {
      event.stopPropagation();
      setShowFilterList(!showFilterList);
    }
  }, showFilterList ? 'filter_list_off' : 'filter_list')), /*#__PURE__*/_react.default.createElement("div", {
    className: "table-filter"
  }, showFilterList && /*#__PURE__*/_react.default.createElement("div", {
    className: "table-filter-search-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "filter-overlay"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "search-field"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row has-text-weight-bold pb-2 pr-6"
  }, "Search"), /*#__PURE__*/_react.default.createElement("div", {
    className: "row pb-2"
  }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
    name: 'search',
    placeholder: 'Search',
    showLabel: false,
    required: false,
    value: search,
    minLength: 0,
    maxLength: 256,
    key: "notchanged",
    iconRight: "search",
    onChange: (name, value) => handleSearch(value)
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "filter-list"
  }, /*#__PURE__*/_react.default.createElement("div", {
    key: "filter_item_select_all"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "field pb-2"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "control"
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: "checkbox"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "checkbox",
    value: "all",
    onChange: event => {
      event.stopPropagation();
      handleSelectAll(!selectAll);
    },
    checked: selectAll
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "has-text-weight-normal"
  }, "Select All"))))), searchItems.map((item, index) => /*#__PURE__*/_react.default.createElement("div", {
    key: `filter_item_${item}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "field pb-2"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "control"
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: "checkbox"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "checkbox",
    value: item,
    onChange: event => {
      event.stopPropagation();
      handleFilterCheckboxClick(item);
    },
    checked: searchChecked[index]
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "has-text-weight-normal"
  }, item)))))))))));
};
TableFilter.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.object),
  active: _propTypes.default.object,
  navigationHandler: _propTypes.default.func,
  handleFilterChange: _propTypes.default.func,
  columnName: _propTypes.default.string,
  columnClassName: _propTypes.default.string,
  columnHeadingClassName: _propTypes.default.string,
  className: _propTypes.default.string,
  resetFilter: _propTypes.default.number,
  openFilterList: _propTypes.default.number
};
TableFilter.defaultProps = {
  columnName: '',
  items: [],
  active: {
    label: ''
  },
  handleFilterChange: () => {},
  columnClassName: '',
  columnHeadingClassName: '',
  className: '',
  resetFilter: 0,
  openFilterList: 0
};
var _default = exports.default = TableFilter;
//# sourceMappingURL=TableFilter.js.map